import { CaseDraft, ChatAnswerType, ChatItem } from '../store/types';
import { ChatRequestMessage } from './types';

const chatHistoryIncludedTypes: ChatAnswerType[] = [ChatAnswerType.ok, ChatAnswerType.caseCreated];

export const mapChatItemToChatRequestMessage = (chatItems: ChatItem[]): ChatRequestMessage[] => {
  return chatItems
    .filter((item) => chatHistoryIncludedTypes.includes(item.answer.type))
    .flatMap((item) => [
      { content: normalizeWhitespace(item.question), role: 'user' },
      {
        content: normalizeWhitespace(item.answer.content),
        role: 'assistant',
      },
    ]);
};

// finds last not sen draft
export const getLastDraft = (chatItems: ChatItem[]): CaseDraft | undefined => {
  let draft: CaseDraft | undefined;

  for (const item of chatItems.toReversed()) {
    if (item.answer.draft) {
      draft = item.answer.draft;
      break;
    }
    if (item.answer.type === ChatAnswerType.caseCreated) {
      break;
    }
  }

  return draft;
};

export const normalizeWhitespace = (text: string): string =>
  text.replace(/(&nbsp;|[\u00A0\u2000-\u200B\u3000]|[ \t])+/g, ' ');
